
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    count: 0,
    current: null,
    page: 1
}

const ACTIONS = {
    GET: 'factures/get',
    GET_ALL: 'factures/getAll',
    GET_NEXT: 'factures/getNext'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }